export const getTextAssetRecommendationsStyles = () => ({
  TextAssetRecommendationsContent: {
    '& .text-recommendation-title': {
      fontWeight: 'bold',
      fontSize: '14px',
      padding: '8px 9px 8px 9px',
    },
    '& .ms-Button': {
      border: 'none',
      textAlign: 'left',
      paddingLeft: '5px',
      marginLeft: '0px',
      marginBottom: '5px',
      '& .ms-Button-label': {
        fontWeight: 'normal',
        fontSize: '14px',
      },
    },
  },
});

export const getFinalUrlRecommendationsStyles = () => ({
  TextFinalUrlRecommendationsContent: {
    '& .text-recommendation-title': {
      fontWeight: 'bold',
      fontSize: '14px',
      padding: '8px 9px 8px 9px',
    },
    '& .ms-Button': {
      border: 'none',
      textAlign: 'left',
      paddingLeft: '5px',
      marginLeft: '0px',
      marginBottom: '5px',
      '& .ms-Button-label': {
        fontWeight: 'normal',
        fontSize: '14px',
      },
    },
  },
});

export const getTextAssetRecommendationsDropdownStyles = () => ({
  TextAssetRecommendationsDropdown: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    maxHeight: 250,
    width: '100%',

    '& li': {
      display: 'list-item',
      fontSize: 14,
      height: 36,
    },

    '& .text-asset-recommendation-theme-icon': {
      position: 'absolute',
      left: 12,
      marginTop: 12,
    },

    '& .text-asset-recommendation-theme-title': {
      borderTop: '1px solid #f3f2f1',
      fontWeight: 'bold',
      padding: '12px 8px 0 36px',
    },

    '& .text-asset-recommendation-asset': {
      '& .ms-Button': {
        border: 'none',
        height: 36,
        width: '100%',
        margin: 0,
        padding: '0 8px 0 32px',
        textAlign: 'left',

        '& .ms-Button-label': {
          fontWeight: 'normal',
        },
      },
    },
  },
});
